import API from '@/services/API'
import store from '@/store/store'
import AuthenticationService from '@/services/AuthenticationService'

export default {
	async toggle (task) {
		try {
			await API.put(`task/toggle`, task, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return
		} catch (err) {
			if (err.response.status === 401) AuthenticationService.logout()
		}
	}
}
